import { useSelector } from 'react-redux';

import { Box, Typography } from '@material-ui/core';

import Button from '../../Button/Button.component';

import { useSetDefaultCard } from 'hooks/payments.hook';

const SetDefaultCardForm = () => {
  const { target } = useSelector(state => state.payments);

  const { mutate, isLoading } = useSetDefaultCard();

  const onClickHandler = event => {
    event.preventDefault();
    mutate(target.id);
  };

  return (
    <>
      <Typography align="center">
        ¿Confirmas que deseas que esta tarjeta sea tu forma de pago principal?
      </Typography>
      <br />
      <Typography align="center">
        Tu suscripción premium y pases se cobrarán con esta forma de pago.
      </Typography>
      <Box pt={2} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          loading={isLoading}
          onClick={onClickHandler}
        >
          Confirmar
        </Button>
      </Box>
    </>
  );
};

export default SetDefaultCardForm;
